import * as React from 'react';
/**
 * React component that can scroll to itself using scrollInView when its shouldScrollTo prop is true.
 *
 * @param props
 */
export var ScrollTo = function (props) {
    var _a = props.shouldScrollTo, shouldScrollTo = _a === void 0 ? true : _a, _b = props.delay, delay = _b === void 0 ? 20 : _b, children = props.children, _c = props.position, position = _c === void 0 ? 'center' : _c, scrollMargin = props.scrollMargin;
    var scrollToRef = React.useRef(null);
    React.useEffect(function () {
        if (!shouldScrollTo) {
            return;
        }
        if (!scrollToRef.current) {
            return;
        }
        // Scroll into view after a short delay.
        setTimeout(function () {
            if (!scrollToRef.current) {
                return;
            }
            scrollToRef.current.scrollIntoView({
                behavior: 'smooth',
                block: position,
            });
        }, delay);
    }, [shouldScrollTo, delay]);
    return (React.createElement("div", { ref: shouldScrollTo ? scrollToRef : null, className: "scroll-to " + (shouldScrollTo ? 'scroll-to-active' : ''), style: { scrollMargin: scrollMargin } }, children));
};
//# sourceMappingURL=ScrollTo.js.map